export const sources = {
  HELP_LINK: 'uf.ui.user.help_link',
};

export const events = {
  GO_TO_FIRST_PROJECT: 'uf.ui.user.user_menu.go_to_first_project',
};
